<template>
	<div class="small-12 sidebarWidget animated fadeIn" style="padding-top:10px;" v-if="resident">
        <div class="small-12 title">
            <h3 class="flex vertical-align">Resident Details</h3>
        </div>
        <div class="small-12 residentDetailsWidget border light borderRadius8">
            <div class="small-12 bgWrap flex justify-center">
                <picture class="round flex justify-center vertical-align">
                    <b>{{ resident.attributes.contact_information.first_name | abbreviateName }} {{ resident.attributes.contact_information.last_name | abbreviateName}}</b>
                </picture>
            </div>
            <div class="small-12 referralCode columns flex justify-center">
                <div class="small-12 columns wrap borderRadius8 bgWhite flex justify-center">
                    <h6 class="small-12 columns text-center">{{ resident.attributes.contact_information.first_name }} {{ resident.attributes.contact_information.last_name }}</h6>
                    <p class="small-12 columns flex justify-center email">
                        {{ resident.attributes.contact_information.email }}
                    </p>
                    <div class="small-12 separator flex justify-center">
                        <span class="round"></span>
                    </div>
                    <small>Resident since {{ resident.meta.created_at | unixToYear }}</small>
                </div>
            </div>
            <div class="small-12 viewResident flex justify-center">
                <router-link :to="{ name: 'Resident', params: { id: $route.params.id, residentID: resident.id } }" class="blueButton flex vertical-align borderRadius4">
                    <i class="material-icons-outlined flex vertical-align justify-center">find_in_page</i>
                    View Resident
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

    // Import the events
	import { GetPropertyResident } from '@/events/residents/GetPropertyResident'

    // Import the filters
	import { DatesFilters } from '@/mixins/filters/DatesFilters'
    import { AbbreviateNameFilter } from '@/mixins/filters/AbbreviateNameFilter'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'UnitResident',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
            GetPropertyResident,
            DatesFilters,
            AbbreviateNameFilter

		],

		/*
		**  Set the props
		*/

		props: {

			unit: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			unit: {

				immediate: true, // Load on created
				handler(unit) {

					/*
					**	Get the resident
					**	@method: Events/Residents/GetPropertyResident
					*/

					if (unit) this.getPropertyResidentHandler(unit.relationships.resident);

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>